import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Home, LifeBuoy } from "lucide-react";
import { activityHubFor } from "@/lib/siteNav";
import { track } from "@/lib/track";

/** Slim bar shown instead of the full header while a child is inside an activity: Back · brand · Help · Home. */
export default function ActivityTopBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const back = () => {
    track("activity_back", { route: pathname });
    if (window.history.length > 1 && window.history.state?.idx > 0) navigate(-1);
    else navigate(activityHubFor(pathname));
  };
  const btn = "inline-flex items-center justify-center gap-1 min-h-[44px] min-w-[44px] px-3 rounded-full border-2 border-slate-900 bg-white font-bold text-xs shadow-[0_2px_0_0_rgba(15,23,42,1)] hover:-translate-y-0.5 transition-transform";
  return (
    <header className="sticky top-0 z-40 border-b-4 border-slate-900 bg-paper-100 dark:bg-night-900" data-testid="activity-topbar" data-activity-mode="1">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 h-14 flex items-center gap-2">
        <button type="button" onClick={back} className={btn} data-testid="activity-back" aria-label="Back"><ArrowLeft size={16} strokeWidth={3} /> Back</button>
        <Link to="/" className="flex-1 min-w-0 flex items-center justify-center gap-2" data-testid="activity-brand" aria-label="My World Quest home">
          <img src="/favicon-32.png" alt="" className="h-7 w-7 object-contain" />
          <span className="font-heading font-black text-sm truncate">My World Quest</span>
        </Link>
        <Link to="/help" className={`${btn} hidden sm:inline-flex`} data-testid="activity-help" aria-label="Help"><LifeBuoy size={16} strokeWidth={3} /></Link>
        <Link to="/" className={btn} data-testid="activity-home" aria-label="Home"><Home size={16} strokeWidth={3} /></Link>
      </div>
    </header>
  );
}
